<script setup lang="ts">
import { RouterView } from 'vue-router'
import { Toaster } from 'vue-sonner'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'vue-sonner/style.css'

dayjs.locale('zh-cn')
</script>

<template>
  <RouterView />
  <Toaster position="top-right" :gap="10" :toast-options="{ unstyled: false, style: { maxWidth: '420px' } }" rich-colors />
</template>

<style>
#app {
  height: 100vh;
}

@media (max-width: 768px) {
  [data-sonner-toaster] {
    left: 12px !important;
    right: 12px !important;
    top: max(10px, env(safe-area-inset-top)) !important;
    width: auto !important;
    max-width: none !important;
  }

  [data-sonner-toast] {
    width: 100% !important;
    max-width: none !important;
  }
}
</style>
